package one.healthium.log_period.domain

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.PeriodLogModel
import kotlin.time.Instant

class PeriodTrackerInteractor(
    private val userInteractor: UserInteractor,
    private val periodRepository: PeriodTrackerRepository
) {

    fun observePeriodLog(): Flow<PeriodLogModel> {
        return userInteractor.observeUser().map { it.periodLogs }
    }

    fun getTipForDay(day: Int): String? {
        return periodRepository.getTipFortDay(day)
    }

    suspend fun setPeriods(days: List<Instant>) {
        userInteractor.setPeriods(days)
    }
}

